<template>
  <div id="trivia" class="row">
    <div class="col-xs-12 trivia-header">
      <slot></slot>
      <div class="trivia-progress">
        <progress-bar
          :percent="triviaProgressPercent"
          :height="12"
        ></progress-bar>
        <div class="progress-text">
          {{ answeredTriviaQuestions }}<slash class="progress-slash" /><span class="all-count">{{ allTriviaQuestions }}</span>
        </div>
      </div>
    </div>
    <div v-if="triviaComplete" class="col-xs-10 col-xs-offset-1">
      <empty-state></empty-state>
    </div>
    <trivia-question
      v-else
      :key="questionKey"
      :question="currentTriviaQuestion"
      @next="nextQuestion"
    />
  </div>
</template>
<!----------------------------------------------------------------------------->
<script>
import { mapGetters } from "vuex";
import find from "lodash/find";
import minBy from "lodash/minBy";

import ProgressBar from "Components/common/ProgressBar";
import Slash from "Components/Svg/Slash";
import EmptyState from "./EmptyState";
import TriviaQuestion from "./TriviaQuestion";

export default {
  name: "Trivia",

  components: { EmptyState, Slash, ProgressBar, TriviaQuestion },

  computed: {
    ...mapGetters(["chapter"]),
    currentTriviaQuestion() {
      return find(this.chapter.triviaQuestions, {
        id: this.currentTriviaQuestionId,
      });
    },
    answeredTriviaQuestions() {
      return this.chapter.triviaQuestions.filter((q) => q.state.answered)
        .length;
    },
    allTriviaQuestions() {
      return this.chapter.triviaQuestions.length;
    },
    triviaProgressPercent() {
      return (this.answeredTriviaQuestions / this.allTriviaQuestions) * 100;
    },
    triviaComplete() {
      return this.answeredTriviaQuestions === this.allTriviaQuestions;
    },
  },

  data() {
    return {
      currentTriviaQuestionId: null,
      questionKey: 0,
      attempts: {},
    };
  },

  created() {
    this.currentTriviaQuestionId = this.getNextUnansweredQuestionId();
  },

  methods: {
    getNextUnansweredQuestionId() {
      const unanswered = this.chapter.triviaQuestions.filter(
        (q) => !q.state.answered
      );
      return minBy(unanswered, (q) => this.attempts[q.id] || 0)?.id;
    },
    nextQuestion() {
      const categoryId = this.$route.params.category;
      const chapterId = this.$route.params.chapter;
      this.attempts[this.currentTriviaQuestionId] =
        (this.attempts[this.currentTriviaQuestionId] ?? 0) + 1;
      return this.$store
        .dispatch("downloadChapter", { categoryId, chapterId })
        .then(() => {
          this.currentTriviaQuestionId = this.getNextUnansweredQuestionId();
          this.questionKey++;
        });
    },
  },
};
</script>
<!----------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
.trivia-header {
  display: flex;
  align-items: center;
  gap: 12px;

  .trivia-progress {
    flex: 1;
  }
}

.progress-slash {
    width: 6px;
    height: 10px;
    margin: 0 2px;
}
</style>
